import styled from 'styled-components';
import { media, mediaQuery } from '../../../common/styles/styleUtil';

export const ProjectArticlesWrapper = styled.div`
  border-top: solid 1px #d2d6da;
  width: 100%;
  padding: 32px 0 10px;
  @media (${mediaQuery.tablet}) {
    width: auto;
    margin: 0 24px;
  }
  ${media.xs`
    padding-top: 24px;
    margin: 0 16px;
  `};
`;

export const ProjectArticlesTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #333f48;
  padding-bottom: 16px;
`;

export const ProjectArticlesContent = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) =>
    props.isFlexStart ? 'flex-start' : 'space-between'};
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
`;

export const Wrapper = styled.li`
  display: inline-block;
  margin-bottom: 30px;
  @media (${mediaQuery.tablet}) {
    margin-bottom: 16px;
  }
  @media (${mediaQuery.mobile}) {
    &:last-of-type {
      margin-bottom: 0;
    }
  }
  &.wrapper {
    &:first-of-type {
      margin-right: 30px;
      @media (${mediaQuery.tablet}) {
        margin-right: 16px;
      }
    }
    .card-content {
      ${media.xs`
        padding-left: 8px;
      `}
    }
  }
`;
